import { SnackBarService } from "@teammood/shared/ui/snack-bar";
import { Team, TeamService, TeamSettings } from '@teammood/team';
import { UserService } from 'app/frontend/lib/shared/util/user';
import { AccountService } from '../../setup/account/account.service';
import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { LoggerService } from "@teammood/shared/util/logger";
import {
    TeamDefaultsSettingsFormComponent
} from "../../team/team-settings/team-defaults-settings-form/team-defaults-settings-form.component";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'default-settings',
    templateUrl: './default-settings.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DefaultSettingsComponent implements OnInit {
  
  @ViewChild(TeamDefaultsSettingsFormComponent)
  teamForm: TeamDefaultsSettingsFormComponent;

  team: Team;
  timezone: string;
  step: { id: string; index: number; } = { id: 'settings', index: 2 };
  constructor(
    private log: LoggerService,
    private userService: UserService,
    private teamService: TeamService,
    private accountService: AccountService,
    private snackBarService: SnackBarService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  async ngOnInit() {
    try {
      const user = await this.userService.get();
      try {
        this.team = await this.teamService.get(user.teamId);
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch (error) {
        this.log.error("Error getting the user", error)
      }
    } catch (error) {
      this.log.error("Error getting the team", error);
    }
  }
  next () {
    const newTeamSettings: TeamSettings = this.teamForm.form.getRawValue();
    const team = { ...this.team, ...newTeamSettings }
    team.moodsDisplayTime = null

    if (team) {
      this.teamService.update(team).then(async () => {
            // update the team member with those settings
            return this.accountService.get().then((teamMember) => {
                teamMember.notificationTime = team.notificationTime;
                teamMember.language = team.language;

                teamMember.teams = teamMember.teams.map(
                    (current_team:any) => {
                        if (current_team.teamId === team.id) {
                            current_team.workingDays = team.workingDays;
                        }
                        return current_team;
                    }
                );

                this.accountService.update(teamMember).then(async () => {
                    await this.router.navigate(['/onboarding', this.route.snapshot.params['userId'], 'teammembers']);
                }).catch((error) => {
                    this.log.error(error);
                    this.snackBarService.error(error);
                });

            });
        })
        .catch((error) => {
          this.log.error('Error on team setting update:', error);
          this.snackBarService.error('Error saving the team settings: ' + JSON.stringify(error.error));
        });
    }
  }
}